/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { getEmployees, createEmployee, getPositions, hideModal } from "actions";
import toastr from "toastr";
import Select from "react-select";

class CreateEmployee extends Component {
  state = {
    name: null,
    surname: null,
    emailAddress: null,
    emailAddressAgain: null,
    selectedPosition: null,
    phoneNumber: null,
    selectedEducationLevel: null,
    selectedBirthdate: null,
    selectedLanguage: null,

    positions: [],
    educationLevels: [
      { value: 1, label: "Clear All" },
      { value: 2, label: "Elementary" },
      { value: 3, label: "Highschool" },
      { value: 5, label: "Vocational High School" },
      { value: 6, label: "Pre-Graduate" },
      { value: 7, label: "Under Graduate" },
      { value: 8, label: "Graduate" },
      { value: 9, label: "Phd" },
    ],
    languages: [
      { value: 14337, label: "AR" },
      { value: 1031, label: "DE" },
      { value: 1033, label: "EN" },
      { value: 1034, label: "ES" },
      { value: 1036, label: "FR" },
      { value: 1050, label: "HR" },
      { value: 1049, label: "RU" },
      { value: 1055, label: "TR" },
    ],
  };

  componentDidMount() {
    this.getPositions();
  }

  getPositions() {
    this.props.getPositions(
      null,
      this.onBegin,
      this.onFetchPositionSuccess,
      this.onError
    );
  }

  getEmployees = () => {
    this.props.getEmployees(this.onBegin, this.onSuccess, this.onError);
  };

  createEmployee() {
    if (!this.checkRequirementFields()) return;

    let formData = {
      name: this.state.name,
      surname: this.state.surname,
      positionId: this.state.selectedPosition,
      // educationLevel: this.state.selectedEducationLevel,
      // birthdate: this.state.selectedBirthdate,
      emailAddress: this.state.emailAddress,
      phoneNumber: this.state.phoneNumber,
      language: this.state.selectedLanguage,
    };

    this.props.createEmployee(
      formData,
      this.onBegin,
      this.onCreateEmployeeSuccess,
      this.onError
    );
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
  };

  onCreateEmployeeSuccess = (res) => {
    toastr.success(i18n.t("10570"));
    this.getEmployees();
    this.props.onProcessEnd();
    this.props.hideModal();
  };

  onFetchPositionSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({ positions: res.data.data.positions });
  };

  checkRequirementFields() {
    if (this.state.name === null || this.state.name === "") {
      //Ad alanı boş bırakılamaz
      toastr.error(i18n.t("10579"));
      return false;
    }

    if (this.state.surname === null || this.state.surname === "") {
      //Soyad alanı boş bırakılamaz
      toastr.error(i18n.t("10580"));
      return false;
    }

    if (this.state.emailAddress === null || this.state.emailAddress === "") {
      //E-posta adresi alanı boş bırakılamaz
      toastr.error(i18n.t("10581"));
      return false;
    }

    if (!this.validateEmail(this.state.emailAddress)) {
      //E-posta adresi geçersiz
      toastr.error(i18n.t("10582"));
      return false;
    }

    if (
      this.state.emailAddressAgain === null ||
      this.state.emailAddressAgain === ""
    ) {
      //E-posta adresi tekrar alanı boş bırakılamaz
      toastr.error(i18n.t("10593"));
      return false;
    }

    if (this.state.emailAddress !== this.state.emailAddressAgain) {
      //E-posta adresleri farklı
      toastr.error(i18n.t("10594"));
      return false;
    }

    if (this.state.selectedPosition === null) {
      //Pozisyon alanı boş bırakılamaz
      toastr.error(i18n.t("10583"));
      return false;
    }

    // if (this.state.selectedEducationLevel === null) {
    //   //Eğitim Seviyesi alanı boş bırakılamaz
    //   toastr.error(i18n.t("10584"));
    //   return false;
    // }

    return true;
  }

  validateEmail(email) {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      return true;
    }
    return false;
  }

  renderFormHeader() {
    return null;
  }

  renderFormBody() {
    return (
      <div>
        <p className="mb-3" style={{ color: "red" }}>
          {i18n
            .t("employeemanagement_add-employee-desc")
            .replace("___dealername___", this.props.generalProfile.companyName)}
          <hr />
        </p>
        <form>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="name">
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                <Trans desc="Ad">10571</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder={i18n.t("10571")}
                onChange={(e) => this.setState({ name: e.currentTarget.value })}
              ></input>
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="surname">
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                <Trans desc="Soyad">10572</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="surname"
                placeholder={i18n.t("10572")}
                onChange={(e) =>
                  this.setState({ surname: e.currentTarget.value })
                }
              ></input>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="email">
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                <Trans desc="E-Posta Adresi">10573</Trans>
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder={i18n.t("10573")}
                onChange={(e) =>
                  this.setState({ emailAddress: e.currentTarget.value })
                }
              ></input>
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="emailAgain">
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                <Trans desc="E-Posta Adresi Tekrar">10592</Trans>
              </label>
              <input
                type="email"
                className="form-control"
                id="emailAgain"
                placeholder={i18n.t("10592")}
                onCut={(e) => e.preventDefault()}
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onChange={(e) =>
                  this.setState({ emailAddressAgain: e.currentTarget.value })
                }
              ></input>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="name">
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                <Trans desc="Pozisyon">10574</Trans>
              </label>
              <Select
                options={this.state.positions.map((position) => {
                  return { value: position.id, label: position.name };
                })}
                onChange={(e) => this.setState({ selectedPosition: e.value })}
                placeholder={i18n.t("10574")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="phoneNumber">
                <Trans desc="Telefon Numarası">10575</Trans>
              </label>
              <input
                type="text"
                className="form-control"
                id="phoneNumber"
                placeholder={i18n.t("10575")}
                onChange={(e) =>
                  this.setState({ phoneNumber: e.currentTarget.value })
                }
              ></input>
            </div>
          </div>

          {/* <div className="form-row">
            <div className="form-group col-md-6">
              <label htmlFor="name">
                <Trans desc="Eğitim Seviyesi">10576</Trans>
              </label>
              <Select
                options={this.state.educationLevels}
                onChange={(e) =>
                  this.setState({ selectedEducationLevel: e.value })
                }
                placeholder={i18n.t("10576")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="birthdate">
                <Trans desc="Doğum Tarihi">10577</Trans>
              </label>
              <input
                type="date"
                className="form-control"
                id="birthdate"
                onChange={(e) =>
                  this.setState({
                    selectedBirthdate: new Date(e.currentTarget.value),
                  })
                }
              ></input>
            </div>
          </div> */}

          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                <Trans desc="Dil Tercihi">
                  employeemanagement_preferred-language
                </Trans>
              </label>
              <Select
                options={this.state.languages}
                onChange={(e) =>
                  this.setState({
                    selectedLanguage: e.value,
                  })
                }
                placeholder={i18n.t("employeemanagement_preferred-language")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="form-group col-md-6"></div>
          </div>

          <div className="form-row col-md-12">
            <span style={{ color: "red" }}>
              <Trans desc="* Doldurulması zorunludur">10595</Trans>
            </span>
          </div>
        </form>
      </div>
    );
  }

  renderFormFooter() {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn-action btn-blue"
          onClick={() => this.createEmployee()}
        >
          <Trans desc="Kaydet">10578</Trans>
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.spinner}
        {this.renderFormHeader()}
        {this.renderFormBody()}
        {this.renderFormFooter()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
  };
};

export default connect(mapStateToProps, {
  getEmployees,
  createEmployee,
  getPositions,
  hideModal,
})(containsLongRunningProcess(requireAuth(CreateEmployee)));
